import EventEmitter from 'es6-eventemitter';
import Socket from 'socket.io-client';
import Config from './../config';

export default class SupervisorService {

    constructor(http){
        this.events = new EventEmitter();
        this.http = http;
        this.queues = [];
    }

    getSummaryInfo(){
        return this.http.get('api/supervisor/summary').then(this._checkError);
    }

    getNodes(){
        return this.http.get('api/supervisor/nodes').then(this._checkError);
    }

    restartSupervisor(){
        return this.http.post('api/supervisor/restart').then(this._checkError);
    }


    restartGroup(node, groupName){
        return this.http.post('api/supervisor/restart-group', {
            node: node,
            group: groupName
        }).then(this._checkError);
    }

    stopGroup(node, groupName){
        return this.http.post('api/supervisor/stop-group', {
            node: node,
            group: groupName
        }).then(this._checkError);
    }

    startGroup(node, groupName){
        return this.http.post('api/supervisor/start-group', {
            node: node,
            group: groupName
        }).then(this._checkError);
    }

    restartWorker(node, group, worker){
        return this.http.post('api/supervisor/restart-worker', {
            node: node,
            process: worker,
            group
        }).then(this._checkError);
    }

    stopWorker(node, group, worker){
        return this.http.post('api/supervisor/stop-worker', {
            node: node,
            process: worker,
            group
        }).then(this._checkError);
    }

    startWorker(node, group, worker){
        return this.http.post('api/supervisor/start-worker', {
            node: node,
            process: worker,
            group
        }).then(this._checkError);
    }

    reloadConfig(node){
        return this.http.post('api/supervisor/reload', {
            node: node
        }).then(this._checkError);
    }

    _checkError(response){
        if(response.data && !response.data.err){
            return Promise.resolve(response);
        }
        let error = _.get(response, 'data.err') || {};
        return Promise.reject(error);
    }
}


// WEBPACK FOOTER //
// ./src/services/supervisor.service.js